import styled from 'styled-components';
import { BrandColor, FunctionColor, mediaMinWidth } from '@lux/core';
import { Text } from '@lux/text';
export const Wrapper = styled.div.withConfig({ displayName: "Wrapper", componentId: "sc-ycbf5e" }) `width:100px;position:absolute;bottom:-2px;left:20px;${mediaMinWidth.sm}{bottom:0px;left:27px;}`;
export const Link = styled.a.withConfig({ displayName: "Link", componentId: "sc-ruul2i" }) `color:${props => {
    if (props.active) {
        return BrandColor.primary;
    }
    if (props.isWithSignUp) {
        return FunctionColor.function100;
    }
    return FunctionColor.function100;
}};padding-right:10px;text-decoration:none;:hover{color:${BrandColor.primary};}${Text}{transition:color 0.4s ease;color:inherit;}`;
//# sourceMappingURL=styles.js.map